import { render, staticRenderFns } from "./ExtensionLicense.vue?vue&type=template&id=011b563c&scoped=true&"
import script from "./ExtensionLicense.vue?vue&type=script&lang=ts&"
export * from "./ExtensionLicense.vue?vue&type=script&lang=ts&"
import style0 from "./ExtensionLicense.vue?vue&type=style&index=0&id=011b563c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b563c",
  null
  
)

export default component.exports